import { ImpersonationPanel } from "../../../../admin/impersonation/ImpersonationPanel";
import { ImpersonationWrapper } from "../../../../admin/impersonation/ImpersonationWrapper";
import DynamicIntlProvider from "../../../../shared/components/DynamicIntlProvider/DynamicIntlProvider";
import { BaseContainer } from "../../../../shared/containers/BaseContainer/BaseContainer";
import { useLocalStorage } from "../../../../shared/hooks/useLocalStorage";
import { useToggle } from "../../../../shared/hooks/useToggle";
import { JwtService } from "../../../../shared/services/Jwt.service";
import { Navbar } from "../../components/Navbar/Navbar";

import { type NavbarNgProps } from "../../navbar.types";

interface Props {
  ngProps: NavbarNgProps;
}

const IMPERSONATION_PANEL_HIDDEN_KEY = "impersonation-panel-hidden";

const NavbarWrapper = (props: React.PropsWithChildren<Props>) => {
  const { children } = props;
  const { ngProps } = props;
  const [panelHidden, setPanelHidden] = useLocalStorage(
    IMPERSONATION_PANEL_HIDDEN_KEY,
    false,
  );
  const impersonation = useToggle(
    JwtService.isImpersonatedToken() || (ngProps.isAdmin && !panelHidden),
  );

  const handleImpersonationToggle = () => {
    setPanelHidden(impersonation.on);
    impersonation.toggle();
  };

  return (
    <DynamicIntlProvider locale={ngProps.langId}>
      <BaseContainer>
        {children}
        <Navbar
          ngProps={ngProps}
          onImpersonationToggle={handleImpersonationToggle}
        />
        {impersonation.on ? (
          <ImpersonationWrapper>
            <ImpersonationPanel
              farm={ngProps.farm}
              toggle={handleImpersonationToggle}
            />
          </ImpersonationWrapper>
        ) : null}
      </BaseContainer>
    </DynamicIntlProvider>
  );
};

export { NavbarWrapper };
